import { useState } from "react";
import { Form } from "antd";

import { type ScheduledTeamMemberTaskAutomation } from "@fitness-app/data-models/entities/AutomationTemplate";

import { type TeamMemberTaskFormModel } from "./types";

export const useTeamMemberTaskForm = () => {
  const [visible, toggleVisibility] = useState(false);
  const [formController] = Form.useForm<TeamMemberTaskFormModel>();
  const [editedTask, setTask] = useState<null | TeamMemberTaskFormModel>(null);

  const closeModal = () => {
    toggleVisibility(false);
    setTask(null);
  };

  const openModal = (task?: ScheduledTeamMemberTaskAutomation) => {
    if (task) {
      setTask(task as unknown as TeamMemberTaskFormModel);
    }
    toggleVisibility(true);
  };

  return {
    visible,
    closeModal,
    openModal,
    editedTask,
    formController,
  };
};
